import React from "react";
import { PatientInformationBarNewFlowTemplate } from "themes/application/facility-order-new-flow/components";
import { PatientInformationBarNewFlowViewStore } from 'application/facility-order-new-flow/stores';
import { observer } from "mobx-react";
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new PatientInformationBarNewFlowViewStore(rootStore, componentProps), 'patientInformationBarNewFlowViewStore')
@observer
class PatientInformationBarNewFlow extends React.Component {
	render() {
		return <PatientInformationBarNewFlowTemplate {...this.props} />;
	}
}

export default PatientInformationBarNewFlow;